<template>
	<!-- [ Main Content ] start -->
	<div>
		<PoliticalParties v-if="user_can_view_registration_dashboard" />

		<StaffDashboard v-if="user_can_view_staff_dashboard" />

		<!-- <PartyDashboard v-if="user_can_view_party_dashboard" /> -->

		<PartyDashboardLinks v-if="user_can_view_party_dashboard" />
	</div>
	<!-- [ Main Content ] end -->
</template>
<script>
import StaffDashboard from "./partials/StaffDashboard.vue";
import PoliticalParties from "./partials/PoliticalParties.vue";
// import PartyDashboard from "./partials/PartyDashboard.vue";
import PartyDashboardLinks from "./partials/PartyDashboardLinks.vue";
import { userHasPermission } from "@/utils/permissions";

export default {
	components: {
		PoliticalParties,
		StaffDashboard,
		// PartyDashboard,
		PartyDashboardLinks,
	},
	computed: {
		user_can_view_staff_dashboard() {
			return userHasPermission("staff-dashboard-view");
		},
		user_can_view_party_dashboard() {
			return userHasPermission("party-dashboard-view");
		},
		user_can_view_registration_dashboard() {
			return userHasPermission("party-registration-view");
		},
	},
};
</script>
